const GET_WORK_ORDER_BY_NUMBER = `
  query GetWorkOrderByNumber($workOrderNumber: Int!){
    workOrders: work_orders(where: {
      work_order_number: { _eq: $workOrderNumber }
    }) {
      id
      afterHours: after_hours
      createdAt: created_at
      description
      endDate: end_date
      workOrderNumber: work_order_number
      status {
        name
      }
      tasks {
        id
        name
      }
    }
  }
`

export default GET_WORK_ORDER_BY_NUMBER
